import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

// Styles
import PageSectionWrapper from "../styles/PageSectionWrapper";
import ChildContentWrapper from "../styles/ChildContentWrapper";

// Components
import SectionStone, { flareOptions, hTypes } from "../components/SectionStone";
import { TitleWrapperPropTypes } from "../styles/TitleWrapper";

const MediaWrapper = styled.div`
    label: MediaWrapper;
    //Mobile-landscape (and larger)
    @media (min-width: 320px) {
        padding-left: 0;
        padding-right: 0;
        margin-left: auto;
        margin-right: auto;
    }
    //Mobile-landscape (and larger)
    @media (min-width: 480px) {
        padding-left: 0;
        padding-right: 0;
        margin-left: auto;
        margin-right: auto;
    }
    // Tablet-portrait (and larger)
    @media (min-width: 768px) {
        padding-left: 0;
        padding-right: 0;
        margin-left: auto;
        margin-right: auto;
    }
    // Tablet-landscape (and larger)
    @media (min-width: 992px) {
        padding-left: 0;
        padding-right: 0;
        margin-left: auto;
        margin-right: auto;
    }
    // Laptops (and longer)
    @media (min-width: 1200px) {
        padding-left: 0;
        padding-right: 0;
        ${({ direction }) => {
            if (direction === "content-left") {
                return `
                    flex-direction: row;
                    display: flex;
                    justify-content: flex-end;
                    align-content: flex-end;
                    margin-left: auto;
                    margin-right: 30px;
                `;
            }
            return `
                    flex-direction: row-reverse;
                    display: flex;
                    justify-content: flex-end;
                    align-content: flex-end;
                    margin-right: auto;
                    margin-left: 30px;
                `;
        }}
        img {
            max-height: 400px;
            vertical-align: middle;
        }
    }
`;
const ContentWrapper = styled.div`
    label: ContentWrapper;

    text-align: left;

    //Mobile-landscape (and larger)
    @media (min-width: 320px) {
        padding-left: 0;
        padding-right: 0;
        margin-left: 5px;
        margin-right: 5px;
    }
    //Mobile-landscape (and larger)
    @media (min-width: 480px) {
        padding-left: 0;
        padding-right: 0;
        margin-left: 10px;
        margin-right: 10px;
    }
    // Tablet-portrait (and larger)
    @media (min-width: 768px) {
        padding-left: 0;
        padding-right: 0;
        margin-left: 20px;
        margin-right: 20px;
    }
    // Tablet-landscape (and larger)
    @media (min-width: 992px) {
        padding-left: 5px;
        padding-right: 5px;
        margin-left: 30px;
        margin-right: 30px;
    }
    // Laptops (and longer)
    @media (min-width: 1200px) {
        max-width: 40%;
        padding-left: 0;
        padding-right: 20%;
        margin-left: 30px;
        margin-right: 30px;
    }
`;
const BodyWrapper = styled.div`
    label: BodyWrapper;
    color: #262626;
    font-size: 16px;
    font-weight: normal;
    font-family: Effra, Helvetica, Arial, sans-serif;
    letter-spacing: 0.2px;
    line-height: 24px;
    margin: 0;
    & p {
        padding-bottom: 20px;
    }
    & em {
        font-style: italic;
    }
    & strong {
        font-weight: bolder;
    }
    & a {
        color: #0098db;
    }
    & ul {
        padding-bottom: 20px;
        li {
            margin-left: 25px;
            list-style-type: disc;
        }
    }

    @media only screen and (max-width: 600px) {
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 1025px) {
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
    }
`;

const PageSectionStoneText = ({
    dataQa,
    layoutDirection,
    title,
    titleFlare,
    titleHType,
    body,
    childPosition,
    children
}) => {
    return (
        <PageSectionWrapper direction={layoutDirection} data-qa={`content-section-header-${dataQa}`} pageTitle={true}>
            <MediaWrapper id={"media-wrapper"} direction={layoutDirection}>
                <SectionStone flare={titleFlare} hType={titleHType} text={title} />
            </MediaWrapper>
            <ContentWrapper id={"content-wrapper"}>
                {children && childPosition === "top" && <ChildContentWrapper>{children}</ChildContentWrapper>}
                <BodyWrapper
                    id={"body-wrapper"}
                    data-qa={`content-section-body-${dataQa}`}
                    dangerouslySetInnerHTML={{ __html: body }}
                />
                {children && childPosition === "bottom" && <ChildContentWrapper>{children}</ChildContentWrapper>}
            </ContentWrapper>
        </PageSectionWrapper>
    );
};

export const PageSectionStoneTextPropTypes = {
    dataQa: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    layoutDirection: PropTypes.oneOf(["content-left", "content-right"]),
    titleFlare: PropTypes.oneOf(flareOptions),
    titleHType: PropTypes.oneOf(hTypes),
    childPosition: PropTypes.oneOf(["top", "bottom"]),

    ...TitleWrapperPropTypes
};

PageSectionStoneText.defaultProps = {
    childPosition: "bottom",
    layoutDirection: "content-left",

    titleFlare: "blue-stone",
    titleHType: "h2"
};
PageSectionStoneText.propTypes = PageSectionStoneTextPropTypes;
export default PageSectionStoneText;
